import { render, staticRenderFns } from "./SignatureFieldPreview.vue?vue&type=template&id=04dd5d83&scoped=true"
import script from "./SignatureFieldPreview.vue?vue&type=script&lang=js"
export * from "./SignatureFieldPreview.vue?vue&type=script&lang=js"
import style0 from "./SignatureFieldPreview.vue?vue&type=style&index=0&id=04dd5d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd5d83",
  null
  
)

export default component.exports